import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 4rem;
  width: 78rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  & > h2 {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 500;
    text-align: center;
  }
`;

export const RowContainer = styled.div`
  margin: 5rem 0;
  width: 95%;
`;

export const Row = styled.div`
  ${(props) => `
    border-color: ${props.theme.colors.accentRed};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border-style: solid;
  border-width: 0.1rem;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  padding: 1.5rem;

  h2 {
    color: ${(props) =>
      props.theme.colors.blackTextTitle + props.theme.transparencies.p58};
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
  }

  h3 {
    ${(props) => `
      color: ${props.theme.colors.primaryBlue};
    `}
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 0;
  }

  .price {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.6rem;
    font-weight: 800;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  min-height: 6.4rem;
  width: 34.8rem;

  & > img {
    height: 5rem;
    width: 5rem;
  }
`;
